import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export class Pdf {
    yOffset: number;
    pageWidth: number;
    pageHeight: number;
    padding: number;
    pdf: jsPDF;

    constructor(
        pageWidth: number,
        pageHeight: number,
        padding: number,
        pdf: jsPDF
    ) {
        this.yOffset = padding;
        this.pageWidth = pageWidth;
        this.pageHeight = pageHeight + 100;
        this.padding = padding;
        this.pdf = pdf;
    }

    async addElements(elements: NodeListOf<Element>) {
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i] as HTMLElement;
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                scrollY: -window.scrollY,
            });

            const imgData = canvas.toDataURL('image/png');
            const imgWidth = this.pageWidth - 2 * this.padding;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            if (this.yOffset + imgHeight > this.pageHeight - this.padding) {
                this.pdf.addPage();
                this.yOffset = this.padding;
            }

            this.pdf.addImage(imgData, 'PNG', this.padding, this.yOffset, imgWidth, imgHeight);
            this.yOffset += imgHeight + 5; // Add spacing between cards
        }
    }

    save(filename: string) {
        this.pdf.save(filename);
    }
}